import React from "react";
import { useAuth } from "../../hooks/useAuth";
import { Outlet, Link, useLocation } from "react-router-dom";
import PersonIcon from '@mui/icons-material/Person';
import PasswordIcon from '@mui/icons-material/Password';
import HelpIcon from '@mui/icons-material/Help';
import LogoutIcon from '@mui/icons-material/Logout';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import ConsentIcon from '@mui/icons-material/AssignmentTurnedIn';


const SettingsLayout: React.FC = () => {
  const location = useLocation();
  const { openChangePasswordDialog } = useAuth();

  return (
    <div className="profile-layout relative flex items-start">      {/* Sidebar im Header-Stil */}
      <aside className="profile-nav hidden lg:block rounded-lg shadow-lg boxShadow-dropdown py-3 px-2 bg-white mt-12 mr-4 ">
        <div className="flex flex-col w-[20rem] px-2">
          <Link
            to="/settings"
            className={`profile__dropdown__item w-full text-left flex items-center gap-2 rounded-lg hover:bg-[#d6e4f4] py-2 px-3 border-[1px] border-solid mb-2 ${
              location.pathname === "/settings" ? "border-[#32768d]" : "border-transparent"
            }`}
          >
            <div className="profile__dropdown__item__img">
              <PersonIcon fontSize="small" style={{ color: "#32768d" }} />
            </div>
            <p className="!font-normal">Profileinstellungen</p>
          </Link>

          <Link
            to="/settings/planpicker"
            className={`profile__dropdown__item w-full text-left flex items-center gap-2 rounded-lg hover:bg-[#d6e4f4] py-2 px-3 border-[1px] border-solid mb-2 ${location.pathname === "/settings/planpicker" ? "border-[#32768d]" : "border-transparent"}`}
          >
            <div className="profile__dropdown__item__img">
              <SubscriptionsIcon fontSize="small" style={{ color: "#32768d" }} />
            </div>
            <p className="!font-normal">Abonnement verwalten
</p>
          </Link>

             <Link
            to="/settings/ChangePassword"
            className={`profile__dropdown__item w-full text-left flex items-center gap-2 rounded-lg hover:bg-[#d6e4f4] py-2 px-3 border-[1px] border-solid mb-2 ${location.pathname === "/settings/ChangePassword" ? "border-[#32768d]" : "border-transparent"}`}
          >
            <div className="profile__dropdown__item__img">
              <PasswordIcon fontSize="small" style={{ color: "#32768d" }} />
            </div>
            <p className="!font-normal">Passwort ändern</p>
          </Link>

          <Link
            to="/settings/documentationsettings"
            className={`profile__dropdown__item w-full text-left flex items-center gap-2 rounded-lg hover:bg-[#d6e4f4] py-2 px-3 border-[1px] border-solid mb-2 ${location.pathname === "/settings/documentationsettings" ? "border-[#32768d]" : "border-transparent"}`}
          >
            <div className="profile__dropdown__item__img">
              <NoteAltIcon fontSize="small" style={{ color: "#32768d" }} />
            </div>
            <p className="!font-normal">Dokumentationseinstellungen</p>
          </Link>

           <Link
            to="/settings/clientconsent"
            className={`profile__dropdown__item w-full text-left flex items-center gap-2 rounded-lg hover:bg-[#d6e4f4] py-2 px-3 border-[1px] border-solid mb-2 ${location.pathname === "/settings/clientconsent" ? "border-[#32768d]" : "border-transparent"}`}
          >
            <div className="profile__dropdown__item__img">
              <ConsentIcon fontSize="small" style={{ color: "#32768d" }} />
            </div>
            <p className="!font-normal">Klienteneinwilligung downloaden</p>
          </Link>
            <hr className="border-gray-300 my-2 mx-3 " />
          <a
            href="https://lumanote.de/help/"
            target="_blank"
            rel="noopener noreferrer"
            className="profile__dropdown__item mb-2"
          >
            <div className="profile__dropdown__item__img">
              <HelpIcon fontSize="small" style={{ color: "#32768d" }} />
            </div>
            <p className="!font-normal">Hilfe & Kontakt</p>
          </a>
        </div>
      </aside>

      {/* Seiteninhalt */}
      <main className="flex-1 p-6 overflow-y-auto overflow-x-auto w-full !scrollbar-hide">
        <div className="w-full min-w-full">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default SettingsLayout;
